import React from 'react';
import {resetRoadmap, resetDisplayPointer, addDisplayTile} from "@/modules/commonRoadmapLarge";
import { IRoadmapLargeClass } from "@/types/RoadmapLargeTypes";
import { rouletteReds } from "@/modules/commonMobile";
import nary from "@/modules/nary";

export default class M35 extends IRoadmapLargeClass {
	render() {
		const roadmapArray = [];
		for (let a = 0; a < 9; a++)
			roadmapArray[a] = [];
		
		const history = this.props.history;

		let currentType = "";
		
		const alternatingStyle = "sl-roadmap-alternating";
		const historyBlink = this.props.historyBlink;
		
		resetRoadmap(this, 12);
		resetDisplayPointer(this);
		
		switch (this.props.filter) {
			case "small-big":
				history.forEach((item, idx, ary) => {
					let ele = null;
					
					const angka = Number(item.angka);
					
					if (angka <= 18 && angka > 0) {
						currentType = "small";
						ele = <div className={"sl-roadmap-circle sl-roadmap-red " + (historyBlink && (idx === ary.length - 1) ? alternatingStyle : null)} />;
					} else {
						currentType = "big";
						ele = <div className={"sl-roadmap-circle sl-roadmap-black " + (historyBlink && (idx === ary.length - 1) ? alternatingStyle : null)} />;
					}
					
					addDisplayTile(roadmapArray, ele, currentType, this);
				});
			break;
			case "odd-even":
				history.forEach((item, idx, ary) => {
					let ele = null;
					
					if (Number(item.angka) % 2 &&
						Number(item.angka) > 0) {
						currentType = "odd";
						ele = <div className={"sl-roadmap-square sl-roadmap-red " + (historyBlink && (idx === ary.length - 1) ? alternatingStyle : null)} />;
					} else {
						currentType = "even";
						ele = <div className={"sl-roadmap-square sl-roadmap-black " + (historyBlink && (idx === ary.length - 1) ? alternatingStyle : null)} />;
					}

					addDisplayTile(roadmapArray, ele, currentType, this);
				});
			break;
			case "red-black":
				history.forEach((item, idx, ary) => {
					let ele = null;
					
					if ((rouletteReds.indexOf(Number(item.angka)) >= 0) &&
						Number(item.angka) > 0) {
						currentType = "red";
						ele = <div className={"sl-roadmap-diamond sl-roadmap-red " + (historyBlink && (idx === ary.length - 1) ? alternatingStyle : null)} />;
					} else {
						currentType = "black";
						ele = <div className={"sl-roadmap-diamond sl-roadmap-black " + (historyBlink && (idx === ary.length - 1) ? alternatingStyle : null)} />;
					}

					addDisplayTile(roadmapArray, ele, currentType, this);
				});
			break;
			default: return null;
		}

		const roadmapTable = 
				(<table className="roadmap-table">
					<tbody>
					{
						nary(8).map(row => 
							<tr key={"RL_p7_row_" + row}>
							{
								nary(12).map(col =>
									(
										<td key={"RL_p7_row_" + row + "col_" + col}>
										{
											roadmapArray[row - 1][col + this.firstDisplayedCol] !== undefined ?
											roadmapArray[row - 1][col + this.firstDisplayedCol] : null
										}
										</td>
									)
								)
							}
							</tr>
						)
					}
					</tbody>
				</table>);
				
		return roadmapTable;
	}
}
